module.exports = __webpack_public_path__ + "static/media/Storage.6d3e3dec.svg";